/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateEstimatedBasicCostRequest } from '../../models/update-estimated-basic-cost-request';

export interface UpdateEstimatedBasicCost$Params {
  id: string;
      body: UpdateEstimatedBasicCostRequest
}

export function updateEstimatedBasicCost(http: HttpClient, rootUrl: string, params: UpdateEstimatedBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, updateEstimatedBasicCost.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

updateEstimatedBasicCost.PATH = '/v0/estimatedBasicCost/{id}';
